var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38 22.162c.69.271 1.526.325 2.953.335v.003h9.334v-.003c1.427-.01 2.264-.064 2.952-.335 1.144-.45 2.052-1.314 2.526-2.4.355-.816.355-1.85.355-3.917v-4.103c0-1.194 0-1.79-.135-2.346a4.896 4.896 0 0 0-1.04-2.022c-.378-.442-.874-.809-1.865-1.542l-3.162-2.338c-1.365-1.01-2.047-1.514-2.783-1.754a4.896 4.896 0 0 0-3.03 0c-.736.24-1.418.745-2.783 1.754L4.54 5.832c-.99.733-1.486 1.1-1.865 1.542a4.896 4.896 0 0 0-1.04 2.022c-.135.556-.135 1.152-.135 2.346v4.103c0 2.067 0 3.1.355 3.916.474 1.087 1.382 1.951 2.526 2.401ZM15 13.5H9v7h6v-7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/homeFilled.6c5463dfe4e081224910bae96ed9025f.svg";
export { ForwardRef as ReactComponent };